export type ColorKeys =
  | "primary"
  | "white"
  | "status-success"
  | "warning"
  | "error"
  | "muted"
  | "emphasis"
  | "slate-20"
  | "slate-14"
  | "slate-28"
  | "border-divider"
  | "transparent"
  | "blue-30"
  | "blue-15"
  | "disabled"
  | "lightblue-a01"
  | "lightblue-a02"
  | "lightblue-a03"
  | "secondary"
  | "blue-48";

export type ColorProps = {
  bg?: ColorKeys;
  text?: ColorKeys;
  color?: ColorKeys;
  border?: ColorKeys;
};

export type ColorPropsKeys = keyof ColorProps;
const colorPropsKeys: ColorPropsKeys[] = ["bg", "text", "color", "border"];

export const createColorClasses = <TProps extends ColorProps>(
  props: TProps,
) => {
  return colorPropsKeys
    .map((key) => {
      if (!props[key]) return "";

      if (key === "color") return `text-${props[key]}`;
      return `${key}-${props[key]}`;
    })
    .filter(Boolean);
};
